import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import useRaceStore from '@/stores/raceStore';
import WatchHeader from '@/components/watch/Header';
import WatchGrid from '@/components/watch/WatchGrid';

const Watch = () => {
  const [ongoingRaces, fetchOngoingRaces] = useRaceStore(
    useShallow(state => [state.ongoingRaces, state.fetchOngoingRaces])
  );

  useEffect(() => {
    fetchOngoingRaces();
  }, [fetchOngoingRaces]);

  return (
    <div className="mx-auto w-full max-w-screen-xl rounded-2xl py-[30px]">
      <WatchHeader />
      <WatchGrid races={ongoingRaces.races} isLoading={ongoingRaces.isLoading} error={ongoingRaces.error} />
    </div>
  );
};

export default Watch;
